<!--  收益管理 -->
<template>
  <el-container class="revenue-management">
    <el-header class="header-card" height="150px">
      <el-card>
        <el-image class="icon">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
        <div class="balance-block">
          <h5 class="font-warning">账户余额</h5>
          <p class="font-warning">500元</p>
        </div>
        <el-button type="primary" size="medium">申请提现</el-button>
      </el-card>
    </el-header>
    <el-main class="main-card">
      <el-card>
        <div slot="header" class="clearfix">
          <el-date-picker
            v-model="time"
            type="datetime"
            placeholder="选择日期时间">
          </el-date-picker>
        </div>
        <ul class="list">
          <li class="clearfix">
            <div class="fleft">
              <p>收益</p>
              <p class="font-info">2017-05-01 15:00</p>
            </div>
            <div class="fright">
              <p class="font-success">+5</p>
              <p class="font-info">300元</p>
            </div>
          </li>
          <li class="clearfix">
            <div class="fleft">
              <p>收益</p>
              <p class="font-info">2017-05-01 15:00</p>
            </div>
            <div class="fright">
              <p class="font-danger">-15</p>
              <p class="font-info">300元</p>
            </div>
          </li>
          <li class="clearfix">
            <div class="fleft">
              <p>收益</p>
              <p class="font-info">2017-05-01 15:00</p>
            </div>
            <div class="fright">
              <p class="font-success">+5</p>
              <p class="font-info">300元</p>
            </div>
          </li>
        </ul>
      </el-card>
    </el-main>
  </el-container>
</template>
<script>
export default {
  data () {
    return {
      time: ''
    }
  }
}
</script>
<style lang="less">
  @import "../../../assets/css/revenue.less";
</style>
